var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useFetch } from "../../utils/use-fetch";
export var usePreview = function (values, token, noCropMarks) {
    if (noCropMarks === void 0) { noCropMarks = false; }
    var formData = new FormData();
    formData.append("ReCaptchaToken", token);
    for (var value in values) {
        if (value === "image") {
            formData.append(value, values[value].file);
            continue;
        }
        if (noCropMarks && value == "cropMarks") {
            formData.append(value, "no");
            continue;
        }
        if (value == "projects") {
            var cnt = 0;
            var projects = values[value];
            for (var projectName in projects) {
                var project = projects[projectName];
                for (var key in project) {
                    if (key == "date") {
                        var date = project[key];
                        for (var dateAttr in date) {
                            formData.append("projects[" + cnt + "][" + key + "][" + dateAttr + "]", date[dateAttr]);
                        }
                        continue;
                    }
                    if (noCropMarks && key == "cropMarks") {
                        formData.append("projects[" + cnt + "][" + key + "]", "no");
                        continue;
                    }
                    formData.append("projects[" + cnt + "][" + key + "]", project[key]);
                }
                cnt++;
            }
            continue;
        }
        formData.append(value, values[value]);
    }
    var _a = __read(useFetch({
        path: "/sfzp/v1/generator/generate",
        method: "POST",
        body: formData,
    }), 3), url = _a[0], loading = _a[1], message = _a[2];
    // console.log(`data:application/pdf;base64,${url}`);
    return { loading: loading, url: url, message: message };
};
export var getTooltips = function () {
    var _a = __read(useFetch({
        path: "/sfzp/v1/tooltip/get-tooltips",
        method: "POST",
    }), 3), tooltips = _a[0], loadingTooltips = _a[1], messageTooltips = _a[2];
    return { tooltips: tooltips, loadingTooltips: loadingTooltips, messageTooltips: messageTooltips };
};
